import React from 'react';
import { 
  Breadcrumbs as MuiBreadcrumbs, 
  Typography, 
  Link, 
  Box,
  useTheme
} from '@mui/material';
import { NavigateNext, Home } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

const Breadcrumbs = ({ items = [] }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  // Auto-generate breadcrumbs based on current path if no items provided
  const generateBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs = [{ label: 'Dashboard', path: '/dashboard' }];

    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      
      // Skip dashboard as it's already added
      if (segment === 'dashboard') return;
      
      // Convert path segments to readable labels
      let label = segment
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      
      // Special cases for known routes
      if (segment === 'loan-types') label = 'Loan Types';
      if (segment === 'account-master') label = 'Account Master';
      if (segment === 'masters') label = 'Masters';
      
      breadcrumbs.push({
        label,
        path: currentPath,
        isLast: index === pathSegments.length - 1
      });
    });

    return breadcrumbs;
  };

  const breadcrumbItems = items.length > 0 ? items : generateBreadcrumbs();

  const handleClick = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      <MuiBreadcrumbs
        separator={<NavigateNext fontSize="small" />}
        aria-label="breadcrumb"
        sx={{
          '& .MuiBreadcrumbs-separator': {
            color: 'text.secondary',
            mx: 0.5,
          },
        }}
      >
        {breadcrumbItems.map((item, index) => {
          const isLast = index === breadcrumbItems.length - 1;
          
          return isLast ? (
            <Typography
              key={item.path || index}
              color="text.primary"
              sx={{
                fontSize: '0.875rem',
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
              }}
            >
              {index === 0 && <Home fontSize="small" />}
              {item.label}
            </Typography>
          ) : (
            <Link
              key={item.path || index}
              underline="hover"
              color="text.secondary"
              onClick={() => handleClick(item.path)}
              sx={{
                cursor: 'pointer',
                fontSize: '0.875rem',
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                '&:hover': {
                  color: 'primary.main',
                },
                transition: theme.transitions.create('color', {
                  duration: theme.transitions.duration.short,
                }),
              }}
            >
              {index === 0 && <Home fontSize="small" />}
              {item.label}
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs;